// D11: after a new quote version is booked, ask whether to restart follow-up emails
// that were stopped by hand on the previous version.
//
// Every "New Version" path books through quotationRequest() in sendRequest.js, and the
// form that does it closes straight after, so the question is asked by one dialog
// mounted in App.vue (FollowupRevisionDialog.vue), told about the booking on the event bus.
import EventBus from '@/event-bus'
import { FOLLOWUP_EMAILS_ON } from '@/featureFlags'

export const QUOTE_VERSION_BOOKED = 'quote-version-booked'

// Emitted with { oppId, quoteVerId } after follow-ups were changed from outside the enquiry's
// Follow-up tab (D11's "Yes"), so an open tab showing that enquiry reloads.
export const FOLLOWUP_CHANGED = 'followup-changed'

/**
 * Called after a successful booking. Never throws: the quote is saved whatever happens here.
 * `bookedId` is the booking response (the new quote_ver_id), used to make sure the question
 * is about the version just booked.
 */
export function announceQuoteVersionBooked(oppId, bookedId) {
  if (!FOLLOWUP_EMAILS_ON) return // stage 1: follow-up emails off, nothing to restart (featureFlags.js)
  try {
    var id = oppId && typeof oppId === 'object' ? oppId.oppId : oppId
    if (id === null || id === undefined || id === '') return
    EventBus.$emit(QUOTE_VERSION_BOOKED, { oppId: id, quoteVerId: bookedId })
  } catch (e) {
    console.error('follow-up: could not announce the booking', e)
  }
}

/**
 * Whether byOpp's answer asks the D11 question for the version just booked. When the booking
 * response is an id and byOpp is about a different version, the answer is not about this booking.
 * Only a user who may act (canAct) is asked: for anyone else the backend refuses the enrol
 * (409 "You do not have permission to do this"), so asking would only lead to an error.
 */
export function shouldAsk(byOpp, bookedId) {
  if (!byOpp || byOpp.askReenrol !== true || byOpp.canAct !== true || !byOpp.quoteVerId) return false
  var booked = Number(bookedId)
  if (bookedId !== null && bookedId !== undefined && bookedId !== '' && !isNaN(booked)) {
    return Number(byOpp.quoteVerId) === booked
  }
  return true
}
